export default __webpack_public_path__ + "static/media/Foot_right.5af06381.svg";